import _ from 'lodash';
import productService from '../../../../services/products';

function getMoveDirection(item, tac) {
  //Not implemented
  return 'center';
}

function moveSuperSection(section, superSection, diff, direction) {
  //Not implemented
}

function getChangeDimension(item) {
  if (productService.isSection(item)) {
    return 'depth';
  }
}

function getSelectedChild(item, optionItems, switchingProp) {
  const isCabinetWood = item.items.some(
    childItem => childItem.filter.color === 'wood'
  );

  const [[dominantSwitchingPropValue]] = Object.entries(
    item.items
      .filter(childItem => !productService.isAddOnShelf(childItem))
      .reduce((switchingPropValues, childItem) => {
        if (isCabinetWood && productService.isCabinet(childItem)) {
          switchingPropValues.wood = switchingPropValues.wood
            ? switchingPropValues.wood + 1
            : 1;
        } else if (switchingPropValues[childItem.filter[switchingProp]]) {
          switchingPropValues[childItem.filter[switchingProp]]++;
        } else {
          switchingPropValues[childItem.filter[switchingProp]] = 1;
        }
        return switchingPropValues;
      }, {})
  ).sort((a, b) => _.clamp(b[1] - a[1], -1, 1));

  const hasDivergentItems = !item.items.every(childItem => {
    if (childItem.filter[switchingProp] === dominantSwitchingPropValue) {
      return true;
    }
    const canSwap =
      productService.getSwappables(childItem, {
        depth: childItem.filter.depth,
        width: childItem.filter.width,
        [switchingProp]: dominantSwitchingPropValue,
      }).length > 0;

    return !canSwap;
  });

  return {
    hasDivergentItems,
    filter: { [switchingProp]: dominantSwitchingPropValue },
  };
}

export default {
  getMoveDirection,
  moveSuperSection,
  getChangeDimension,
  getSelectedChild,
};
